import api from '../../../services/api';
import { NewSizePriceData, Size, SizePriceData } from './models';

export function getSizesPrices(
  sizesPrices = [],
  sizes = [],
  product = {},
  groupSizes = [],
) {
  const prices = [...sizesPrices];
  const seenIds = new Set(sizesPrices.map(({ IdTamanho }) => IdTamanho));

  for (let index = 0; index < sizes.length; index++) {
    const size = sizes[index];
    const groupSize = groupSizes.find(({ IdTamanho }) => IdTamanho === size.Id);
    const hasSize = size?.Id && seenIds.has(size.Id);
    const isPizzaGroup = product?.IsPizza || product?.TipoProduto === 'PIZZA';
    const noGroupSizesConfigured = groupSizes.length === 0;
    const activePizzaGroupSize = noGroupSizesConfigured ? true : groupSize?.Ativo;
    const activeSize = sizes[index]?.Ativo;

    if ((!isPizzaGroup || activePizzaGroupSize) && !hasSize && activeSize) {
      prices.push(Size(size, product, index));
      seenIds.add(size.Id);
    }
  }

  return prices;
}

function isNewSizePrice(id) {
  return Number.isSafeInteger(Number(id));
}

export function mapSizesPrices(tamPrice) {
  const patchEndpoint = `/produto-tamanho/alterar/${tamPrice.Id}`;
  const createEndpoint = `/produto-tamanho/criar`;

  if (isNewSizePrice(tamPrice?.Id) && tamPrice.Preco > 0) {
    return api.post(createEndpoint, NewSizePriceData(tamPrice));
  }

  return api.patch(patchEndpoint, SizePriceData(tamPrice));
}
